import { render, staticRenderFns } from "./productVersion.vue?vue&type=template&id=2a6b2ce5&"
import script from "./productVersion.vue?vue&type=script&lang=js&"
export * from "./productVersion.vue?vue&type=script&lang=js&"
import style0 from "./productVersion.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports